import jwtAuthAxios from "services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ENV_PRODUCTION } from "services/environmentService";

const withAuth = () => {
    const token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
};

// Copy selalu dijalankan dari konteks production: auth admin di-resolve ke DB production,
// jadi tetap bisa dipakai walau DB development belum terisi.
const prodHeaders = { 'X-App-Env': ENV_PRODUCTION };

export const startCopyProdToDev = createAsyncThunk(
    "environmentConfig/startCopy",
    async (_, { rejectWithValue }) => {
        try {
            withAuth();
            const r = await jwtAuthAxios.post('v1/admin/db-copy/prod-to-dev', {}, { headers: prodHeaders });
            return r.data;
        } catch (err) {
            return rejectWithValue(err?.response?.data || { message: err.message });
        }
    }
);

export const getCopyStatus = createAsyncThunk(
    "environmentConfig/getStatus",
    async (jobId, { rejectWithValue }) => {
        try {
            withAuth();
            const r = await jwtAuthAxios.get(`v1/admin/db-copy/status/${jobId}`, { headers: prodHeaders });
            return r.data;
        } catch (err) {
            return rejectWithValue(err?.response?.data || { message: err.message });
        }
    }
);

const initialState = {
    copying: false,
    job: null,
};

const environmentConfigSlice = createSlice({
    name: "environmentConfig",
    initialState,
    reducers: {
        resetCopyJob: (state) => { state.job = null; },
    },
    extraReducers: (builder) => {
        builder
            .addCase(startCopyProdToDev.pending, (state) => { state.copying = true; state.job = null; })
            .addCase(startCopyProdToDev.fulfilled, (state, action) => { state.copying = false; state.job = action.payload; })
            .addCase(startCopyProdToDev.rejected, (state) => { state.copying = false; });

        builder
            .addCase(getCopyStatus.fulfilled, (state, action) => { state.job = action.payload; });
    },
});

export const { resetCopyJob } = environmentConfigSlice.actions;
export const environmentConfigSelector = (state) => state.environmentConfig;
export default environmentConfigSlice.reducer;
